import React from 'react';

import styles from '../newStatsTabContent.scss';

const NumberStats = props => {
    const { statValue, statLabel, gradientInfo, ratingTrend, infoButton } = props;
    return (
        <div className={styles.numberStats}>
            <div className={`${styles.statValue}`}>
                {ratingTrend} {statValue}
            </div>
            <div className={`${styles.statType}`}>
                {statLabel} {infoButton}
            </div>
            {gradientInfo}
        </div>
    );
};

export default NumberStats;
